import { z } from "zod";

export const EditWorkingHourFormSchema = z.object({
  open_at: z.string().regex(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/, {
    message: "Horário de abertura inválido",
  }),
  close_at: z.string().regex(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/, {
    message: "Horário de fechamento inválido",
  }),
});
